import { loaders, FullProjectIssue } from 'entities';

import { Skeleton } from 'components/Blocks';

import { NoIssue } from './NoIssue';
import { IssueList } from './IssueList';
import { IssueModal } from './IssueModal';

import { useProjectProfile } from '../context';

import { listGet, listUpdate } from 'utils/array';

export function Issues() {
  const { id, queryParams, setQueryParams } = useProjectProfile();

  const focusedIssueId = queryParams.issueId;

  const issues = loaders.projects.listProjectIssues.use({
    defaultValue: [],

    params: {
      projectId: id,
    },

    onDataChange: (issueList) =>
      !listGet(issueList, focusedIssueId) && setQueryParams({ issueId: null }),
  });

  const registerNewIssue = (issue: FullProjectIssue): void =>
    issues.overwrite((issues) => [...issues, issue]);

  const updateIssue = (issue: FullProjectIssue): void =>
    issues.overwrite((issues) => listUpdate(issues, issue));

  if (!issues.errorOrLoading && !issues.data.length)
    return <NoIssue registerNewIssue={registerNewIssue} />;

  if (issues.errorOrLoading) return <Skeleton quantity={5} height={36} />;

  return (
    <>
      <IssueModal
        close={() => setQueryParams({ issueId: null })}
        issue={listGet(issues.data, focusedIssueId)}
        updateIssue={updateIssue}
      />

      <IssueList
        issues={issues.data}
        openIssue={(issueId) => setQueryParams({ issueId })}
        registerNewIssue={registerNewIssue}
      />
    </>
  );
}
